import * as React from 'react';
const SvgGoogleCloud = (props) => (
  <svg viewBox="0 0 69 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m45.694 15.808 5.972-6.191.398-2.607C41.181-3.25 23.88-2.086 14.07 9.437c-2.725 3.2-4.747 7.19-5.825 11.31l2.139-.312 11.945-2.042.922-.978c5.313-6.049 14.297-6.862 20.432-1.716l2.012.109Z"
      fill="#EA4335"
    />
    <path
      d="M60.174 20.565c-1.373-5.24-4.191-9.952-8.11-13.555l-8.382 8.69c3.54 2.997 5.556 7.514 5.47 12.25v1.543c4.12 0 7.46 3.463 7.46 7.733 0 4.272-3.34 7.647-7.46 7.647H34.21l-1.467 1.65V55.8l1.467 1.456H49.15c10.717.086 19.472-8.762 19.556-19.871.05-6.734-3.152-13.046-8.533-16.819Z"
      fill="#4285F4"
    />
    <path
      d="M19.29 57.255h14.92V44.873H19.29a7.105 7.105 0 0 1-3.06-.695l-2.117.673-6.014 6.191-.524 2.107c3.373 2.64 7.488 4.125 11.714 4.106Z"
      fill="#34A853"
    />
    <path
      d="M19.29 17.09C8.571 17.155-.065 26.214 0 37.323c.036 6.204 2.831 12.044 7.575 15.825l8.655-8.971c-3.755-1.759-5.424-6.34-3.727-10.232 1.696-3.892 6.115-5.622 9.87-3.863a7.603 7.603 0 0 1 3.727 3.863l8.655-8.971c-3.683-4.99-9.405-7.908-15.466-7.886Z"
      fill="#FBBC05"
    />
  </svg>
);
export default SvgGoogleCloud;
